
// import React, { useState, useMemo } from "react";
// import Image from "../../../components/common/Image";
// import { stripHTMLTags } from "../../../utils/helper";
// import _ from "lodash";
// import appRoutes from "../../../routes/app.routes";
// import { openUrlInNewTab } from "../../../utils/helper";
// import Avatar from "../../../components/common/AvtarImage";
// import ReactPlayer from "react-player";
// import NavigateNextIcon from "@material-ui/icons/ArrowForwardIos";
// import ArrowBackIosIcon from "@material-ui/icons/ArrowBackIos";
// import CloseIcon from "@material-ui/icons/Close";

// interface FeedList {
//   data: any;
// }

// // Helper function to parse content and extract media positions
// const parseContentWithMedia = (htmlContent: string, contentMediaProcessed: any = {}) => {
//   if (!htmlContent || !Object.keys(contentMediaProcessed).length) {
//     return [{ type: 'text', content: htmlContent || '' }];
//   }

//   const contentBlocks = [];
//   let currentTextContent = '';
//   let currentIndex = 0;

//   const mediaPattern = /<div[^>]*class="[^"]*ql-media-wrapper[^"]*"[^>]*data-media-id="([^"]+)"[^>]*data-media-type="([^"]+)"[^>]*>.*?<\/div>/gs;
  
//   let match;
//   let lastIndex = 0;

//   while ((match = mediaPattern.exec(htmlContent)) !== null) {
//     const [fullMatch, mediaId, mediaType] = match;
//     const matchStart = match.index;
//     const matchEnd = match.index + fullMatch.length;

//     // Add text content before this media item
//     const textBefore = htmlContent.slice(lastIndex, matchStart);
//     if (textBefore.trim()) {
//       if (currentTextContent) {
//         currentTextContent += textBefore;
//       } else {
//         currentTextContent = textBefore;
//       }
//     }

//     if (currentTextContent.trim()) {
//       contentBlocks.push({
//         type: 'text',
//         content: currentTextContent.trim(),
//         index: currentIndex++
//       });
//       currentTextContent = '';
//     }

//     const mediaItem = contentMediaProcessed[mediaId];
//     if (mediaItem) {
//       contentBlocks.push({
//         type: 'media',
//         mediaId: mediaId,
//         mediaType: mediaType,
//         mediaData: mediaItem,
//         index: currentIndex++
//       });
//     }

//     lastIndex = matchEnd;
//   }

//   // Add any remaining text content
//   const remainingText = htmlContent.slice(lastIndex);
//   if (remainingText.trim()) {
//     currentTextContent += remainingText;
//   }

//   if (currentTextContent.trim()) {
//     contentBlocks.push({
//       type: 'text',
//       content: currentTextContent.trim(),
//       index: currentIndex++
//     });
//   }

//   if (contentBlocks.length === 0) {
//     return [{ type: 'text', content: htmlContent, index: 0 }];
//   }

//   return contentBlocks;
// };

// const FeedListContent = ({ data }: FeedList) => {
//   const [readMore, setReadMore] = useState<boolean>(false);
//   const [videoLoaded, setVideoLoaded] = useState(true);
//   const [media, setMedia] = useState<{ url: string; type: string; }[] | undefined>();
//   const [index, setIndex] = useState(-1);

//   const postText = data?.content || data?.post_text ? String(data?.content || data?.post_text) : "";
//   const stripHTMLText = stripHTMLTags(postText);
//   const postType = _.get(data, "post_type");
//      // eslint-disable-next-line
//   const contentMediaProcessed = data?.content_media_processed || {};
//   const contentBlocks = useMemo(() => {
//     return parseContentWithMedia(postText, contentMediaProcessed);
//   }, [postText, contentMediaProcessed]);

  
//   const allMediaItems = useMemo(() => {
//     const postMedia = (data.post_media || []).map(item => ({
//       url: item.media_type === "image" ? item.media_thumbnail : item.media_original,
//       type: item.media_type === "image" ? "photo" : item.media_type,
//       source: 'post_media'
//     }));

//     const contentMediaItems = Object.keys(contentMediaProcessed).map(mediaId => {
//       const item = contentMediaProcessed[mediaId];
//       return {
//         url: item.signedUrl,
//         type: item.type === "image" ? "photo" : item.type,
//         source: 'content_media',
//         thumbnail: item.thumbnailSignedUrl
//       };
//     });

//     const coverVideoItem = [];
//     if (data.cover_video && postType === 1) {
//       coverVideoItem.push({
//         url: data.cover_video,
//         type: "video",
//         source: 'cover_video',
//         thumbnail: data.cover_image 
//       });
//     }

//     return [...postMedia, ...contentMediaItems, ...coverVideoItem];
//   }, [data.post_media, contentMediaProcessed, data.cover_video, data.cover_image, postType]);

//   const parseTextWithAnchorTags = (text) => {
//     const mentionHashTag = /<span class="mention"[^>]*data-denotation-char="#".*?data-value="([^"]+)".*?><span class="ql-mention-denotation-char">#<\/span>(.*?)<\/span>/g;
//     const hashtagRegex = /#(\w+)/g;

//     return text
//       .replace(mentionHashTag, (match, hashtagValue, hashtagText) => {
//         return `<a href=${appRoutes.Feed.path}/hash-tag/${hashtagValue} target="_blank">#${hashtagText}</a>`;
//       })
//       .replace(hashtagRegex, `<a href=${appRoutes.Feed.path}/hash-tag/$1 target="_blank">#$1</a>`);
//   };

//   const handleClick = (mediaIndex: number) => {
//     setIndex(mediaIndex);
//     setMedia(allMediaItems);
//     setVideoLoaded(true);
//   };

//   const handleClose = () => {
//     setMedia(undefined);
//     setVideoLoaded(false);
//     setIndex(-1);
//   };

//   const handleVideoReady = () => {
//     setVideoLoaded(false);
//   };

//     const handleCoverMediaClick = (e: React.MouseEvent) => {
//     e.stopPropagation();     
//     const coverVideoIndex = allMediaItems.findIndex(item => item.source === 'cover_video');
    
//     if (coverVideoIndex >= 0) {
//       handleClick(coverVideoIndex);
//     }
//   };

//   const handleArticleClick = (e: React.MouseEvent) => {
//     const target = e.target as HTMLElement;
//     const isMediaClick = target.closest('.content-media-item') || 
//                         target.closest('.video-cover') || 
//                         target.closest('.img-wrapper') ||
//                         target.closest('.article-cover-video');
    
//     if (!isMediaClick) {
//       openUrlInNewTab(appRoutes.FeedDetails.generateFullPath(data?.slug));
//     }
//   };

//   function estimateReadMinutes(content: string = ""): number {
//     const plainText = content.replace(/<[^>]+>/g, "");
//     const words = plainText.trim().split(/\s+/).filter(Boolean).length;
//     const wordsPerMinute = 200;
//     const rawMinutes = words / wordsPerMinute;
//     return Math.max(1, Math.ceil(rawMinutes));
//   }

//   const minutes = estimateReadMinutes(data.content);
// const handleOpenUrlInNewTab = () =>{
//   openUrlInNewTab(appRoutes.FeedDetails.generateFullPath(data?.slug));
// }
        
//   // Function to render individual content blocks
//   const renderContentBlock = (block, blockIndex) => {
//     if (block.type === 'text') {
//       const textContent = block.content;
//       const shouldTruncate = stripHTMLText.length > 100 && !readMore && blockIndex === 0;
      
//       return (
//         <div key={`text-${blockIndex}`} className="content-text-block">
//           {shouldTruncate ? (
//             <div
//               className="feed-content-info wysiwyg-data"
//               dangerouslySetInnerHTML={{
//                 __html: parseTextWithAnchorTags(textContent.substring(0, 500)) + "...",
//               }}
//               onClick={handleOpenUrlInNewTab}
//             />
//           ) : (
//             <div
//               className="feed-content-info wysiwyg-data"
//               dangerouslySetInnerHTML={{
//                 __html: parseTextWithAnchorTags(textContent),
//               }}
//               onClick={handleOpenUrlInNewTab}
//             />
//           )}
//         </div>
//       );
//     } else if (block.type === 'media') {
//       // const mediaItem = block.mediaData;
//       // const contentMediaArray = Object.keys(contentMediaProcessed);
//       // const mediaIndex = contentMediaArray.indexOf(block.mediaId) + (data.post_media?.length || 0);
//       //->IF MEDIA SHOW THEN USE THIS CODE 

//       // return (
//       //   <div key={`media-${block.mediaId}`} className="content-media-block">
//       //     <div className="article-img-wrapper">
//       //       <div
//       //         onClick={(e) => {
//       //           e.stopPropagation(); // Prevent article navigation
//       //           handleClick(mediaIndex);
//       //         }}
//       //         className="img-wrapper content-media-item"
//       //       >
//       //         {mediaItem.type === "image" ? (
//       //           <Avatar
//       //             type="post"
//       //             src={mediaItem.signedUrl}
//       //           />
//       //         ) : (
//       //           <div className="video-cover">
//       //             <span className="play-icon-cover">
//       //               <i className="fa fa-play"></i>
//       //             </span>
//       //             <Avatar
//       //               type="post"
//       //               src={mediaItem.thumbnailSignedUrl || mediaItem.signedUrl}
//       //               className="avatar-thumbnail"
//       //             />
//       //           </div>
//       //         )}
//       //       </div>
//       //     </div>
//       //   </div>
//       // );
//     }
//     return null;
//   };

//   return (
//     <div className={`feed-wrapper ${data.content && "feed-details-content"}`}>
//       {!_.isEmpty(postText) && (
//         <div className="sequential-content">
//           {contentBlocks.map((block, blockIndex) => 
//             renderContentBlock(block, blockIndex)
//           )}
          
//           {stripHTMLText.length > 100 && !(postType === 1 )&&  (
//             <span
//               className="span-link d-block mt-2"
//               onClick={() => setReadMore((prevState) => !prevState)}
//             >
//               Read {readMore ? "less" : "more"}
//             </span>
//           )}

//           {postType === 1 && (
//             <div className="list-article">
//               <div onClick={handleArticleClick}>
//                 <div>
//                   <div className="article-image">
//                     {data?.cover_video ? (
//                       // Show video thumbnail with play button if cover_video exists
//                       <div 
//                         className="article-cover-video video-cover"
//                         onClick={handleCoverMediaClick}
//                       >
//                         <Image 
//                           src={data.cover_image} 
//                           alt="video thumbnail" 
//                           className="video-thumbnail"
//                         />
//                         <span className="play-icon-cover">
//                           <i className="fa fa-play"></i>
//                         </span>
//                       </div>
//                     ) : (
//                       // Show regular image if no cover_video
//                       data?.cover_image?.length > 0 && (
//                         <Image src={data.cover_image} alt="media image" />
//                       )
//                     )}
//                   </div>
//                 </div>
//                 <div className="article-short-description">
//                   {/* <div className="article-title">{data.title}</div> */}
//                   <a
//   href={appRoutes.FeedDetails.generateFullPath(data?.slug)}
//   target="_blank"
//   rel="noopener noreferrer"
//   onClick={(e) => e.stopPropagation()}   // parent onClick ko rokne ke liye
//   className="article-title"
// >
//   {data.title}
// </a>

//                   <div>
//                     {data.user.first_name + " " + data.user.last_name + `. ${minutes} min read`}
//                   </div>
//                 </div>
//               </div>
//             </div>
//           )}
//         </div>
//       )}

//       {/* Original post_media rendering for posts that don't have sequential content */}
//       {data.post_media?.length > 0 && Object.keys(contentMediaProcessed).length === 0 && (
//         <div className="feed-img-wrapper">
//           {data.post_media.map((image, i) => (
//             <div
//               onClick={() => handleClick(i)}
//               className="img-wrapper"
//               key={i}
//             >
//               {image.media_type === "image" ? (
//                 <Avatar
//                   type="post"
//                   src={image.media_thumbnail || data.post_media[i]}
//                 />
//               ) : (
//                 <div className="video-cover">
//                   <span className="play-icon-cover">
//                     <i className="fa fa-play"></i>
//                   </span>
//                   <Avatar
//                     type="post"
//                     src={image.media_thumbnail}
//                     className="avatar-thumbnail"
//                   />
//                 </div>
//                 )}
//             </div>
//           ))}
//         </div>
//       )}

//       {/* Media Preview Modal */}
//       {Array.isArray(media) && media.length > 0 && index >= 0 && (
//         <div className="media-preview-overlay" onClick={handleClose}>
//           {index > 0 && (
//             <ArrowBackIosIcon
//               className="nav-btn prev-btn"
//               onClick={(e) => {
//                 e.stopPropagation();
//                 setIndex((prev) => (prev > 0 ? prev - 1 : prev));
//                 setVideoLoaded(true);
//               }}
//             />
//           )}

//           <div
//             className={`media-preview-content ${videoLoaded ? "video-loading" : ""}`}
//             onClick={(e) => e.stopPropagation()}
//           >
//             {media[index].type === "photo" ? (
//               <img
//                 src={media[index].url}
//                 alt="preview"
//                 onLoad={() => setVideoLoaded(false)}
//               />
//             ) : (
//               <ReactPlayer
//                 url={media[index].url}
//                 playing={true}
//                 controls={true}
//                 onReady={handleVideoReady}
//               />
//             )}
//           </div>

//           {index < media.length - 1 && (
//             <NavigateNextIcon
//               className="nav-btn next-btn"
//               onClick={(e) => {
//                 e.stopPropagation();
//                 setIndex((prev) => (prev < media.length - 1 ? prev + 1 : prev));
//                 setVideoLoaded(true);
//               }}
//             />
//           )}
//           <CloseIcon className="close-btn" onClick={handleClose} />
//         </div>
//       )}
//     </div>
//   );
// };

// export default FeedListContent;



import React, { useState, useMemo, useEffect } from "react";
import { createPortal } from "react-dom";
import Image from "../../../components/common/Image";
import { stripHTMLTags } from "../../../utils/helper";
import _ from "lodash";
import appRoutes from "../../../routes/app.routes";
import { openUrlInNewTab } from "../../../utils/helper";
import Avatar from "../../../components/common/AvtarImage";
import VideoPlayerOverlay from "../../../components/common/VideoPlayerOverlay";
import NavigateNextIcon from "@material-ui/icons/ChevronRight";
import ArrowBackIosIcon from "@material-ui/icons/ChevronLeft";
import LinkPreviewCard from "../../../components/common/LinkPreviewCard";
import { CircularProgress } from "@material-ui/core";

interface FeedList {
  data: any;
  feedArticle?: boolean;
}

type ContentBlock =
  | {
      type: "text";
      content: string;
      index: number;
      isTruncated?: boolean;
    }
  | {
      type: "media";
      mediaId: string;
      mediaType: string;
      mediaData: any;
      index: number;
    };

type PreviewMediaItem = {
  url: string;
  type: string;
  source: "post_media" | "content_media" | "cover_video" | "cover_image";
  thumbnail?: string;
  mediaId?: string | null;
};

type PostCarouselItem = PreviewMediaItem & { previewIndex: number };

const asPostMediaArray = (pm: unknown): any[] =>
  Array.isArray(pm) ? pm : [];

// Helper function to parse content and extract media positions
const parseContentWithMedia = (
  htmlContent: string,
  contentMediaProcessed: any = {}
): ContentBlock[] => {
  if (!htmlContent || !Object.keys(contentMediaProcessed).length) {
    return [{ type: "text", content: htmlContent || "", index: 0 }];
  }

  const contentBlocks: ContentBlock[] = [];
  let currentTextContent = "";
  let currentIndex = 0;

  const mediaPattern =
    /<div[^>]*class="[^"]*ql-media-wrapper[^"]*"[^>]*data-media-id="([^"]+)"[^>]*data-media-type="([^"]+)"[^>]*>.*?<\/div>/gs;
  
  let match;
  let lastIndex = 0;

  while ((match = mediaPattern.exec(htmlContent)) !== null) {
    const [fullMatch, mediaId, mediaType] = match;
    const matchStart = match.index;
    const matchEnd = match.index + fullMatch.length;

    // Add text content before this media item
    const textBefore = htmlContent.slice(lastIndex, matchStart);
    if (textBefore.trim()) {
      if (currentTextContent) {
        currentTextContent += textBefore;
      } else {
        currentTextContent = textBefore;
      }
    }

    if (currentTextContent.trim()) {
      contentBlocks.push({
        type: "text",
        content: currentTextContent.trim(),
        index: currentIndex++,
      });
      currentTextContent = "";
    }

    const mediaItem = contentMediaProcessed[mediaId];
    if (mediaItem) {
      contentBlocks.push({
        type: "media",
        mediaId: mediaId,
        mediaType: mediaType,
        mediaData: mediaItem,
        index: currentIndex++,
      });
    }

    lastIndex = matchEnd;
  }

  // Add any remaining text content
  const remainingText = htmlContent.slice(lastIndex);
  if (remainingText.trim()) {
    currentTextContent += remainingText;
  }

  if (currentTextContent.trim()) {
    contentBlocks.push({
      type: "text",
      content: currentTextContent.trim(),
      index: currentIndex++,
    });
  }

  if (contentBlocks.length === 0) {
    return [{ type: "text", content: htmlContent, index: 0 }];
  }

  return contentBlocks;
};

const FeedListContent = ({ data, feedArticle }: FeedList) => {
  const [readMore, setReadMore] = useState<boolean>(false);
  const [photoLoaded, setPhotoLoaded] = useState(true);
  const [previewIndex, setPreviewIndex] = useState(-1);
  const [carouselIndex, setCarouselIndex] = useState(0);

  const postType = _.get(data, "post_type");
  const isArticleFeed = postType === 1 && !feedArticle;
  const isPostFeed = postType !== 1;
  // Article content belongs to the article page. Only the optional message
  // entered in the publish dialog is shown above its feed preview card.
  const postText = isArticleFeed
    ? String(data?.article_caption || data?.post_text || "")
    : String(data?.content || data?.post_text || "");
  const stripHTMLText = stripHTMLTags(postText);
  const postMediaArray = asPostMediaArray(data?.post_media);
  // const contentMediaProcessed = data?.content_media_processed || {};
  
  // const contentBlocks = useMemo(() => {
  //   return parseContentWithMedia(postText, contentMediaProcessed);
  // }, [postText, contentMediaProcessed]);

  // // NEW: Calculate truncated blocks that limit entire content to 500 chars
  // const truncatedBlocks = useMemo(() => {
  //   if (readMore || stripHTMLText.length <= 500) {
  //     return contentBlocks;
  //   }

  //   const truncated = [];
  //   let accumulatedLength = 0;
  //   const CHAR_LIMIT = 500;

  //   for (const block of contentBlocks) {
  //     if (block.type === 'text') {
  //       const blockStripped = stripHTMLTags(block.content);
        
  //       if (accumulatedLength + blockStripped.length <= CHAR_LIMIT) {
  //         // Entire block fits
  //         truncated.push(block);
  //         accumulatedLength += blockStripped.length;
  //       } else {
  //         // Need to truncate this block
  //         const remainingChars = CHAR_LIMIT - accumulatedLength;
  //         if (remainingChars > 0) {
  //           // Find a good breaking point in the HTML
  //           let htmlIndex = 0;
  //           let textCount = 0;
  //           const htmlContent = block.content;
            
  //           // Walk through HTML and count visible text characters
  //           while (htmlIndex < htmlContent.length && textCount < remainingChars) {
  //             if (htmlContent[htmlIndex] === '<') {
  //               // Skip HTML tag
  //               const tagEnd = htmlContent.indexOf('>', htmlIndex);
  //               if (tagEnd !== -1) {
  //                 htmlIndex = tagEnd + 1;
  //               } else {
  //                 break;
  //               }
  //             } else {
  //               // Count visible character
  //               textCount++;
  //               htmlIndex++;
  //             }
  //           }
            
  //           truncated.push({
  //             ...block,
  //             content: block.content.substring(0, htmlIndex),
  //             isTruncated: true
  //           });
  //         }
  //         break; // Stop processing further blocks
  //       }
  //     } else if (block.type === 'media') {
  //       // Skip media in truncated view if we're close to limit
  //       if (accumulatedLength < CHAR_LIMIT - 50) {
  //         truncated.push(block);
  //       }
  //     }
  //   }

  //   return truncated;
  // }, [contentBlocks, readMore, stripHTMLText.length]);

  // const allMediaItems = useMemo(() => {
  //   const postMedia = (data.post_media || []).map(item => ({
  //     url: item.media_type === "image" ? item.media_thumbnail : item.media_original,
  //     type: item.media_type === "image" ? "photo" : item.media_type,
  //     source: 'post_media'
  //   }));

  //   const contentMediaItems = Object.keys(contentMediaProcessed).map(mediaId => {
  //     const item = contentMediaProcessed[mediaId];
  //     return {
  //       url: item.signedUrl,
  //       type: item.type === "image" ? "photo" : item.type,
  //       source: 'content_media',
  //       thumbnail: item.thumbnailSignedUrl
  //     };
  //   });

  //   const coverVideoItem = [];
  //   if (data.cover_video && postType === 1) {
  //     coverVideoItem.push({
  //       url: data.cover_video,
  //       type: "video",
  //       source: 'cover_video',
  //       thumbnail: data.cover_image 
  //     });
  //   }

  //   return [...postMedia, ...contentMediaItems, ...coverVideoItem];
  // }, [data.post_media, contentMediaProcessed, data.cover_video, data.cover_image, postType]);


  const contentMediaProcessed = useMemo(() => data?.content_media_processed || {}, [data?.content_media_processed]);

  const contentBlocks = useMemo(() => {
    return parseContentWithMedia(postText, contentMediaProcessed);
  }, [postText, contentMediaProcessed]);

  // NEW: Calculate truncated blocks that limit entire content to 500 chars
  const truncatedBlocks = useMemo(() => {
    if (readMore || stripHTMLText.length <= 500) {
      return contentBlocks;
    }

    const truncated: ContentBlock[] = [];
    let accumulatedLength = 0;
    const CHAR_LIMIT = 500;

    for (const block of contentBlocks) {
      if (block.type === 'text') {
        const blockStripped = stripHTMLTags(block.content);
        
        if (accumulatedLength + blockStripped.length <= CHAR_LIMIT) {
          // Entire block fits
          truncated.push(block);
          accumulatedLength += blockStripped.length;
        } else {
          // Need to truncate this block
          const remainingChars = CHAR_LIMIT - accumulatedLength;
          if (remainingChars > 0) {
            // Find a good breaking point in the HTML
            let htmlIndex = 0;
            let textCount = 0;
            const htmlContent = block.content;
            
            // Walk through HTML and count visible text characters
            while (htmlIndex < htmlContent.length && textCount < remainingChars) {
              if (htmlContent[htmlIndex] === '<') {
                // Skip HTML tag
                const tagEnd = htmlContent.indexOf('>', htmlIndex);
                if (tagEnd !== -1) {
                  htmlIndex = tagEnd + 1;
                } else {
                  break;
                }
              } else {
                // Count visible character
                textCount++;
                htmlIndex++;
              }
            }
            
            truncated.push({
              ...block,
              content: block.content.substring(0, htmlIndex),
              isTruncated: true
            });
          }
          break; // Stop processing further blocks
        }
      } else if (block.type === 'media') {
        // Skip media in truncated view if we're close to limit
        if (accumulatedLength < CHAR_LIMIT - 50) {
          truncated.push(block);
        }
      }
    }

    return truncated;
  }, [contentBlocks, readMore, stripHTMLText.length]);

  const allMediaItems = useMemo(() => {
    const postMedia: PreviewMediaItem[] = postMediaArray.map((item) => ({
      url:
        item.media_type === "image" ? item.media_thumbnail : item.media_original,
      type: item.media_type === "image" ? "photo" : item.media_type,
      source: "post_media",
      mediaId: null,
      thumbnail:
        item.media_type === "video" ? item.media_thumbnail : undefined,
    }));

    const contentMediaItems: PreviewMediaItem[] = Object.keys(
      contentMediaProcessed
    ).map((mediaId) => {
      const item = contentMediaProcessed[mediaId];
      return {
        url: item.signedUrl,
        type: item.type === "image" ? "photo" : item.type,
        source: "content_media",
        thumbnail: item.thumbnailSignedUrl,
        mediaId,
      };
    });

    const coverMediaItems: PreviewMediaItem[] = [];
    if (postType === 1) {
      if (data?.cover_video) {
        coverMediaItems.push({
          url: data.cover_video,
          type: "video",
          source: "cover_video",
          thumbnail: data?.cover_image,
        });
      } else if (data?.cover_image) {
        coverMediaItems.push({
          url: data.cover_image,
          type: "photo",
          source: "cover_image",
        });
      }
    }

    return [...postMedia, ...contentMediaItems, ...coverMediaItems];
  }, [postMediaArray, contentMediaProcessed, data?.cover_video, data?.cover_image, postType]);

  const hasArticleCover = !!(data?.cover_video || data?.cover_image);

  const postCarouselMedia = useMemo((): PostCarouselItem[] => {
    if (!isPostFeed) return [];
    return allMediaItems
      .map((item, previewIndex) => ({ ...item, previewIndex }))
      .filter(
        (item): item is PostCarouselItem =>
          item.source === "post_media" || item.source === "content_media"
      );
  }, [isPostFeed, allMediaItems]);

  const articleTextBlocks = useMemo(() => {
    if (!isArticleFeed) return truncatedBlocks;
    return truncatedBlocks.filter((block) => block.type === "text");
  }, [isArticleFeed, truncatedBlocks]);

  const postTextBlocks = useMemo(() => {
    if (!isPostFeed || postCarouselMedia.length === 0) return truncatedBlocks;
    return truncatedBlocks.filter((block) => block.type === "text");
  }, [isPostFeed, postCarouselMedia.length, truncatedBlocks]);

  useEffect(() => {
    setCarouselIndex(0);
  }, [data?.id]);

  const parseTextWithAnchorTags = (text) => {
    const mentionHashTag = /<span class="mention"[^>]*data-denotation-char="#".*?data-value="([^"]+)".*?><span class="ql-mention-denotation-char">#<\/span>(.*?)<\/span>/g;
    const anchorTagRegex = /<a\b[^>]*>[\s\S]*?<\/a>/gi;
    const hashtagRegex = /(^|[\s>])#(\w+)/g;

    const applyHashTagToSegment = (segment: string) =>
      segment
        .replace(mentionHashTag, (match, hashtagValue, hashtagText) => {
          return `<a href=${appRoutes.Feed.path}/hash-tag/${hashtagValue} target="_blank">#${hashtagText}</a>`;
        })
        .replace(hashtagRegex, (match, prefix, tag) => {
          return `${prefix}<a href=${appRoutes.Feed.path}/hash-tag/${tag} target="_blank">#${tag}</a>`;
        });

    let output = "";
    let lastIndex = 0;
    let anchorMatch;

    while ((anchorMatch = anchorTagRegex.exec(text)) !== null) {
      output += applyHashTagToSegment(text.slice(lastIndex, anchorMatch.index));
      output += anchorMatch[0];
      lastIndex = anchorMatch.index + anchorMatch[0].length;
    }

    output += applyHashTagToSegment(text.slice(lastIndex));
    return output;
  };

  const currentPreview =
    previewIndex >= 0 ? allMediaItems[previewIndex] : null;
  const canGoPrev = previewIndex > 0;
  const canGoNext =
    previewIndex >= 0 && previewIndex < allMediaItems.length - 1;

  const handleClick = (mediaIndex: number) => {
    setPreviewIndex(mediaIndex);
    setPhotoLoaded(allMediaItems[mediaIndex]?.type === "photo");
  };

  const findContentMediaIndex = (mediaId: string) =>
    allMediaItems.findIndex(
      (item) => item.source === "content_media" && item.mediaId === mediaId
    );

  const handleClose = () => {
    setPreviewIndex(-1);
    setPhotoLoaded(false);
  };

  const goToPreview = (nextIndex: number) => {
    if (nextIndex < 0 || nextIndex >= allMediaItems.length) {
      return;
    }
    setPreviewIndex(nextIndex);
    setPhotoLoaded(allMediaItems[nextIndex]?.type === "photo");
  };

  const goPrev = (e?: React.MouseEvent) => {
    e?.stopPropagation();
    goToPreview(previewIndex - 1);
  };

  const goNext = (e?: React.MouseEvent) => {
    e?.stopPropagation();
    goToPreview(previewIndex + 1);
  };

  const handleCoverMediaClick = (e: React.MouseEvent) => {
    e.stopPropagation();
    openUrlInNewTab(appRoutes.FeedDetails.generateFullPath(data?.slug));
  };

  const handleArticleClick = (e: React.MouseEvent) => {
    const target = e.target as HTMLElement;
    const isMediaClick = target.closest('.content-media-item') || 
                        target.closest('.video-cover') || 
                        target.closest('.img-wrapper') ||
                        target.closest('.article-cover-video');
    
    if (!isMediaClick) {
      openUrlInNewTab(appRoutes.FeedDetails.generateFullPath(data?.slug));
    }
  };

  function estimateReadMinutes(content: string = ""): number {
    const plainText = content.replace(/<[^>]+>/g, "");
    const words = plainText.trim().split(/\s+/).filter(Boolean).length;
    const wordsPerMinute = 200;
    const rawMinutes = words / wordsPerMinute;
    return Math.max(1, Math.ceil(rawMinutes));
  }

  const minutes = estimateReadMinutes(data.content);
  
  // const handleOpenUrlInNewTab = () => {
  //   openUrlInNewTab(appRoutes.FeedDetails.generateFullPath(data?.slug));
  // };

  const handleMentionClick = (e: React.MouseEvent) => {
    const target = e.target as HTMLElement;

    const readMoreEl = target.closest?.(".span-link");
    if (readMoreEl) {
      e.preventDefault();
      e.stopPropagation();
      setReadMore(true);
      return;
    }

    const mentionSpan = target.closest?.(".mention");
    if (!mentionSpan) return;
    const el = mentionSpan as HTMLElement;
    const slug = el.dataset?.slug;
    const isCompany = el.dataset?.is_company === "true" || el.dataset?.isCompany === "true";
    if (slug) {
      e.preventDefault();
      e.stopPropagation();
      const url = isCompany
        ? appRoutes.CompanyPublicView.generatePath(slug)
        : appRoutes.candidatePublicProfile.generateFullPath(slug);
      openUrlInNewTab(url);
    }
  };

  // Function to render individual content blocks
  const renderContentBlock = (block, blockIndex, isLastBlock) => {
    if (block.type === 'text') {
      const textContent = block.content;
      const shouldShowReadMoreLink = !readMore && stripHTMLText.length > 500 && isLastBlock;
      
      return (
        <div key={`text-${blockIndex}`} className="content-text-block">
          <div
            className="feed-content-info wysiwyg-data"
            dangerouslySetInnerHTML={{
              __html:
                parseTextWithAnchorTags(textContent) +
                (shouldShowReadMoreLink ? `... <span class="read-more-link span-link">Read more</span>` : ""),
            }}
          />
        </div>
      );
    } else if (block.type === "media") {
      const mediaItem = block.mediaData;
      const mediaIndex = findContentMediaIndex(block.mediaId);
      const isImage = mediaItem.type === "image";

      return (
        <div
          key={`media-${block.mediaId}`}
          className="content-media-block article-img-wrapper"
        >
          <div
            className={`img-wrapper content-media-item ${
              isImage ? "is-photo" : "is-video"
            }`}
            onClick={(e) => {
              e.stopPropagation();
              if (mediaIndex >= 0) handleClick(mediaIndex);
            }}
            style={{ cursor: "pointer" }}
          >
            {isImage ? (
              <Avatar type="post" src={mediaItem.signedUrl} />
            ) : (
              <div className="video-cover">
                <span className="play-icon-cover">
                  <i className="fa fa-play"></i>
                </span>
                <Avatar
                  type="post"
                  src={mediaItem.thumbnailSignedUrl || mediaItem.signedUrl}
                  className="avatar-thumbnail"
                />
              </div>
            )}
          </div>
        </div>
      );
    }
    return null;
  };

  const renderPostMediaCarousel = () => {
    if (!postCarouselMedia.length) return null;

    const currentItem = postCarouselMedia[carouselIndex];
    const openCurrentInPreview = () => {
      if (currentItem.previewIndex >= 0) handleClick(currentItem.previewIndex);
    };

    return (
      <div className="feed-post-media-carousel">
        <div
          className="carousel-media-wrapper"
          onClick={openCurrentInPreview}
          role="button"
          tabIndex={0}
          onKeyDown={(e) => {
            if (e.key === "Enter" || e.key === " ") {
              e.preventDefault();
              openCurrentInPreview();
            }
          }}
        >
          {currentItem.type === "video" ? (
            <div className="video-cover">
              <Image
                src={currentItem.thumbnail || currentItem.url}
                alt="Video thumbnail"
                className="carousel-image"
              />
              <span className="play-icon-cover">
                <i className="fa fa-play"></i>
              </span>
            </div>
          ) : (
            <Image src={currentItem.url} alt="Post media" className="carousel-image" />
          )}
        </div>

        {postCarouselMedia.length > 1 && (
          <span className="carousel-counter">
            {carouselIndex + 1}/{postCarouselMedia.length}
          </span>
        )}

        {carouselIndex > 0 && (
          <button
            type="button"
            className="carousel-nav-btn prev"
            aria-label="Previous image"
            onClick={(e) => {
              e.stopPropagation();
              setCarouselIndex((prev) => Math.max(0, prev - 1));
            }}
          >
            <ArrowBackIosIcon />
          </button>
        )}

        {carouselIndex < postCarouselMedia.length - 1 && (
          <button
            type="button"
            className="carousel-nav-btn next"
            aria-label="Next image"
            onClick={(e) => {
              e.stopPropagation();
              setCarouselIndex((prev) =>
                Math.min(postCarouselMedia.length - 1, prev + 1)
              );
            }}
          >
            <NavigateNextIcon />
          </button>
        )}
      </div>
    );
  };

  const renderArticleCover = () => {
    if (!hasArticleCover) return null;

    const openArticle = (e: React.MouseEvent) => {
      e.stopPropagation();
      openUrlInNewTab(appRoutes.FeedDetails.generateFullPath(data?.slug));
    };

    return (
      <div
        className="feed-article-cover"
        onClick={openArticle}
        role="button"
        tabIndex={0}
        onKeyDown={(e) => {
          if (e.key === "Enter" || e.key === " ") {
            e.preventDefault();
            openArticle(e as unknown as React.MouseEvent);
          }
        }}
      >
        {data?.cover_video ? (
          <div className="article-cover-video video-cover">
            <Image
              src={data.cover_image}
              alt="Video thumbnail"
              className="video-thumbnail"
            />
            <span className="play-icon-cover">
              <i className="fa fa-play"></i>
            </span>
          </div>
        ) : (
          <Image src={data.cover_image} alt="Article cover" className="cover-image" />
        )}
      </div>
    );
  };

  const renderArticleTitleBar = () => {
    if (!data?.title) return null;

    return (
      <a
        href={appRoutes.FeedDetails.generateFullPath(data?.slug)}
        target="_blank"
        rel="noopener noreferrer"
        onClick={(e) => e.stopPropagation()}
        className="feed-article-title-bar"
      >
        <strong>{data.title}</strong>
        {(data?.user?.first_name || data?.user?.last_name) && (
          <span className="feed-article-author">
            {[data.user.first_name, data.user.last_name].filter(Boolean).join(" ")}
          </span>
        )}
      </a>
    );
  };

  const renderArticleCard = () => (
    <div className="list-article">
      <div onClick={handleArticleClick}>
        <div>
          <div className="article-image">
            {data?.cover_video ? (
              <div
                className="article-cover-video video-cover"
                onClick={handleCoverMediaClick}
              >
                <Image
                  src={data.cover_image}
                  alt="video thumbnail"
                  className="video-thumbnail"
                />
                <span className="play-icon-cover">
                  <i className="fa fa-play"></i>
                </span>
              </div>
            ) : (
              data?.cover_image?.length > 0 && (
                <Image src={data.cover_image} alt="media image" />
              )
            )}
          </div>
        </div>
        <div className="article-short-description">
          <a
            href={appRoutes.FeedDetails.generateFullPath(data?.slug)}
            target="_blank"
            rel="noopener noreferrer"
            onClick={(e) => e.stopPropagation()}
            className="article-title"
          >
            {data.title}
          </a>
          <div>
            {data.user.first_name + " " + data.user.last_name + `. ${minutes} min read`}
          </div>
        </div>
      </div>
    </div>
  );

  const showArticleContent = isArticleFeed
    ? !!(data?.title || !_.isEmpty(postText) || hasArticleCover)
    : !_.isEmpty(postText) || postCarouselMedia.length > 0;

  return (
    <div
      className={`feed-wrapper ${data.content && "feed-details-content"} ${
        isArticleFeed ? "feed-article-layout" : ""
      } ${isPostFeed && postCarouselMedia.length > 0 ? "feed-post-layout" : ""}`}
    >
      {showArticleContent && (
        <div className="sequential-content" onClick={handleMentionClick}>
          {isArticleFeed ? (
            <>
              {!_.isEmpty(postText) &&
                articleTextBlocks.map((block, blockIndex) =>
                  renderContentBlock(
                    block,
                    blockIndex,
                    blockIndex === articleTextBlocks.length - 1
                  )
                )}
              {renderArticleCover()}
              {renderArticleTitleBar()}
            </>
          ) : (
            <>
              {(postCarouselMedia.length > 0 ? postTextBlocks : truncatedBlocks).map(
                (block, blockIndex, arr) =>
                  renderContentBlock(
                    block,
                    blockIndex,
                    blockIndex === arr.length - 1
                  )
              )}
              {renderPostMediaCarousel()}
              {postType === 1 && renderArticleCard()}
              {isPostFeed && data?.link_preview_url && (
                <LinkPreviewCard
                  preview={{
                    url: data.link_preview_url,
                    title: data.link_preview_title,
                    image: data.link_preview_image,
                    domain: data.link_preview_domain,
                  }}
                />
              )}
            </>
          )}
        </div>
      )}

      {/* Fallback grid for posts without carousel-eligible media */}
      {isPostFeed &&
        postCarouselMedia.length === 0 &&
        postMediaArray.length > 0 &&
        Object.keys(contentMediaProcessed).length === 0 && (
        <div className="feed-img-wrapper">
          {postMediaArray.map((image, i) => (
            <div
              onClick={() => handleClick(i)}
              className="img-wrapper"
              key={i}
            >
              {image.media_type === "image" ? (
                <Avatar
                  type="post"
                  src={image.media_thumbnail || postMediaArray[i]}
                />
              ) : (
                <div className="video-cover">
                  <span className="play-icon-cover">
                    <i className="fa fa-play"></i>
                  </span>
                  <Avatar
                    type="post"
                    src={image.media_thumbnail}
                    className="avatar-thumbnail"
                  />
                </div>
              )}
            </div>
          ))}
        </div>
      )}

      {/* Media Preview */}
      {currentPreview?.type === "video" &&
        createPortal(
          <>
            <VideoPlayerOverlay
              key={currentPreview.url}
              open
              onClose={handleClose}
              videoUrl={currentPreview.url}
              videoThumbnail={currentPreview.thumbnail}
            />
            {canGoPrev && (
              <button
                type="button"
                className="feed-preview-nav feed-preview-nav--prev"
                aria-label="Previous media"
                onClick={goPrev}
              >
                <ArrowBackIosIcon />
              </button>
            )}
            {canGoNext && (
              <button
                type="button"
                className="feed-preview-nav feed-preview-nav--next"
                aria-label="Next media"
                onClick={goNext}
              >
                <NavigateNextIcon />
              </button>
            )}
          </>,
          document.body
        )}

      {currentPreview?.type === "photo" &&
        createPortal(
          <div className="media-preview-overlay" onClick={handleClose}>
            {canGoPrev && (
              <button
                type="button"
                className="feed-preview-nav feed-preview-nav--prev"
                aria-label="Previous media"
                onClick={goPrev}
              >
                <ArrowBackIosIcon />
              </button>
            )}

            <div
              className={`media-preview-content ${
                photoLoaded ? "is-loading" : ""
              }`}
              onClick={(e) => e.stopPropagation()}
            >
              {photoLoaded && (
                <div className="media-preview-loader" aria-live="polite">
                  <CircularProgress size={40} style={{ color: "#fff" }} />
                </div>
              )}
              <img
                src={currentPreview.url}
                alt="preview"
                onLoad={() => setPhotoLoaded(false)}
                style={{ maxHeight: "82vh", maxWidth: "92vw" }}
              />
            </div>

            {canGoNext && (
              <button
                type="button"
                className="feed-preview-nav feed-preview-nav--next"
                aria-label="Next media"
                onClick={goNext}
              >
                <NavigateNextIcon />
              </button>
            )}
            <button
              type="button"
              className="video-card-player-close"
              onClick={handleClose}
              aria-label="Close video player"
            >
              &times;
            </button>
          </div>,
          document.body
        )}
    </div>
  );
};

export default FeedListContent;
